import type { FaireProductEntity } from "../../entity_types/product";

export const p_dyeauxn8bv: FaireProductEntity = {
  token: "p_dyeauxn8bv",
  type: "product",
  name: "Gift Set:  Regimen Skincare",
  brandToken: "b_acea3iv0",
  brandName: "Blind Barber",
  imageUrl:
    "https://cdn.faire.com/fastly/2872097a27638c99d05c00d17547cbeb3b865df24de3ae31f2a24e2addbfd718.jpeg",
  galleryImageUrls: [],
  priceDollars: 51,
  description:
    "Your skin faces its fair share of challenges, from environmental pollutants and stress to the simple act of daily shaving. Good news for you, Blind Barber loves a challenge.\n\nIntroducing the Skincare Essentials Set. This collection brings together five essential products designed to transform your skincare routine and elevate your grooming game to new heights.\n\nStay Handsome.\n\nIncludes\n\n * 1 x triRescue Eye Cream .5 FL OZ | 15 ML \n * 1 x B3 Supercharged Balancing Toner 6 FL OZ | 175 ML \n * 1 x elixBoost Hydrating Balm 3.3 FL OZ | 100 ML \n * 1 x activClean Rice Bran Cleanser 5 FL OZ | 150 ML \n * 1 x AHA Refining Face Scrub 6 FL OZ | 175 ML ",
  tags: [],
  msrpDollars: 102,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:12.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
